import * as React from 'react';
import { Box, Typography } from '@mui/material';
import './IndustryCard.css';
import { Link } from 'react-router-dom';

interface IndustryCardProps {
    id: string;
    industryTitle: string;
    imageUrl: string;
    industryDescription: string;
    link: string;
    industriesPerRow: number;
};

const truncateText = (text: string, length: number) => {
    return text.length > length ? text.substring(0, length) + "..." : text;
};

const IndustryCard: React.FC<IndustryCardProps> = ({ id, industryTitle, imageUrl, industryDescription, link, industriesPerRow }) => {
    const truncatedDescription = truncateText(industryDescription, 150);
    return (
        <Box className="industry-card-container industry-card-background">
            <Typography 
                className='industry-card-title-container' id={`${id}-container`}
                sx={{ fontSize: {xs: '19px', sm: '21px', md: '29px', lg: '33px'}}}
            >
                <Box className="industry-card-title" id={`${id}-title`}>{industryTitle}</Box>
            </Typography>
            <Box className='image-container'>
                <img
                    src={`${process.env.REACT_APP_STATIC_FILE_ROUTE}/${imageUrl}`}
                    alt="Card Visual"
                    style={{ display: 'block', width: '100%' }}
                />
            </Box>
            <Box className='industry-card-info-container' id={`${id}-container`}>
                <Typography 
                    className="industry-card-info" id={`${id}-title`}
                    sx={{ fontSize: {xs: '16px', sm: '18px', md: '24px', lg: '28px'}}}
                >
                    <div dangerouslySetInnerHTML={{ __html: truncatedDescription }} />
                </Typography>
            </Box>
            <Box className="industry-card-footer">
                <Link to={link} style={{ textDecoration: 'none' }}>
                    <Box
                        component="button"
                        className="explore-button"
                    >
                        Explore
                    </Box>
                </Link>
            </Box>
        </Box>
    );
};

export default IndustryCard;